
import AudioGroupViewModel from "@models/meditations/create/audioGroupViewModel";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class AudioGroupBlockComponent extends Vue {
  @Prop({ type: Object }) audioGroup: AudioGroupViewModel;
  @Prop({ type: Boolean, default: false }) showDescription: boolean;
  @Prop({ type: Boolean, default: false }) tableView: boolean;
  @Prop({ type: Boolean, default: false }) showItemActions: boolean;
  @Prop({ type: Boolean, default: false }) showSpeech: boolean;
  @Prop({ type: Boolean, default: false }) speechDisabled: boolean;
  @Prop({ type: Function, default: () => false }) speechDirty: (item: any) => boolean;
  @Prop({ type: Number, default: -1 }) groupIndex: number;
  groupSpeechBusy = false;
  languageSpeechBusy = false;
  get speechBusy(): boolean { return this.groupSpeechBusy || this.languageSpeechBusy; }
  get hasUnsavedSpeechChanges(): boolean {
    return (this.audioGroup.audios || []).some(item => this.speechDirty(item) ||
      !item.id && !!((item.description || '').trim() || (item.name || '').trim() || item.audioFile));
  }
  setGroupSpeechBusy(busy: boolean) { this.groupSpeechBusy = busy; this.$emit('speech-busy', this.speechBusy); }
  setLanguageSpeechBusy(busy: boolean) { this.languageSpeechBusy = busy; this.$emit('speech-busy', this.speechBusy); }
  beforeDestroy() { this.$emit('speech-busy', false); }

  get audioFilledFields(): string[] {
    const fields = ["name", "audioUrl"];
    if (this.showDescription) {
      fields.push("description");
    }
    return fields;
  }

  hasAudioContent(item: any): boolean {
    return !!(
      item &&
      (
        (item.name || "").trim() ||
        (item.description || "").trim() ||
        item.audioUrl
      )
    );
  }

  startEdit() {
    if (this.showSpeech && (this.speechDisabled || this.speechBusy)) return;
    this.$emit("edit", this.audioGroup);
  }
  startDelete() {
    if (this.showSpeech && (this.speechDisabled || this.speechBusy)) return;
    this.$emit("delete", this.audioGroup);
  }
  startEditItem(audioItem: any) {
    if (this.showSpeech && (this.speechDisabled || this.speechBusy)) return;
    this.$emit("edit-item", {
      audioItem,
      groupIndex: this.groupIndex,
    });
  }
  startDeleteItem(audioItem: any) {
    if (this.showSpeech && (this.speechDisabled || this.speechBusy)) return;
    this.$emit("delete-item", {
      audioItem,
      groupIndex: this.groupIndex,
    });
  }
}
